/**
 * SplitText Animations
 * Animates heading text word by word on scroll
 */

export function initSplitTextAnimations() {
  const elements = gsap.utils.toArray(".heading-hero-header, .heading-style-h2");
  
  if (elements.length === 0) {
    return; // Exit early if no elements found
  }
  
  elements.forEach((el) => {
    const split = SplitText.create(el, {
      type: "words",
      wordsClass: "split-word",
      mask: "words",
      aria: "auto",
      onSplit(self) {
        return gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        }).from(self.words, {
          yPercent: 100,
          autoAlpha: 0,
          duration: 1,
          ease: "power4.out",
          stagger: 0.1,
          onComplete: () => {
            split.revert();
          }
        });
      }
    });
  });
}
